export default __webpack_public_path__ + "static/media/hotelicoimg.6fd19ac6.jpeg";